const NationalFeeData = {
    coursefee: "11,17,950",
    hostelfee: "4,01,125",
};
export default NationalFeeData;
